import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import "./CardInformativoPcr.css";

const CardInformativoPcr = () => {
  const { textosState } = useContext(PortalContext);
  return (
    <div className="pcr-CardInformativo">
      <div className="pcr-cardInformativo-container">
        <div className="pcr-cardInformativo-header">
          <span className="rb18b c-white">
            Toma de turno de laboratorio para Hisopado por PCR
          </span>
        </div>
        <div className="pcr-cardInformativo-body">
          {textosState.textos.data && (
            <span
              className="rb14m c-white"
              dangerouslySetInnerHTML={{
                __html: textosState.textos.data.cardPCRExterno.descripcion,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardInformativoPcr;
